import { action, computed, makeObservable, observable } from 'mobx';
export class LimitsConfirmationState {
    @observable public checkBoxValue: boolean = false;

    public constructor() {
        makeObservable(this);
    }

    @computed public get isButtonDisabled(): boolean {
        return this.checkBoxValue === false;
    }

    @action public toggleCheckBoxValue = (): void => {
        this.checkBoxValue = !this.checkBoxValue;
    };
}
